import React from 'react'
import { Alert, Button } from '@mui/material'
import { useAppTranslations } from '../../utils/hooks/useAppTranslations'
import { useCurrentUser } from '../../utils/hooks/useUserContext'
import { useImpersonation } from '../../utils/hooks/useImpersonation'

const ImpersonationWarningBanner: React.FC = () => {
  const t = useAppTranslations()
  const { me } = useCurrentUser()
  const { isImpersonating, quitImpersonation } = useImpersonation()

  if (!isImpersonating) return null

  return (
    <Alert
      action={
        <Button
          color="warning"
          data-testid="quitImpersonationButton"
          onClick={() => quitImpersonation()}
          size="small"
          variant="contained"
        >
          {t('impersonation.quit')}
        </Button>
      }
      data-testid="impersonationWarningBanner"
      severity="warning"
      square
      sx={{ borderRadius: 0 }}
    >
      {t('impersonation.banner', {
        firstName: me.firstName,
        lastName: me.lastName,
        email: me.email,
        interpolation: { escapeValue: false },
      })}
    </Alert>
  )
}

export default ImpersonationWarningBanner
